import {Ticket} from '../types';

export type UpdateTicket = (id: string, patch: Partial<Ticket>) => Promise<Ticket>;
export type SaveReply = (approve?: boolean) => Promise<Ticket | null>;

export function persistReply(id: string, draft: string, approve: boolean, update: UpdateTicket): Promise<Ticket> {
  const patch: Partial<Ticket> = {draft};
  if (approve) patch.approved = true;
  return update(id, patch);
}

export async function replyForSharing(ticket: Ticket, dirty: boolean, save: SaveReply): Promise<Ticket | null> {
  return dirty ? save() : ticket;
}